import { MultiValue } from 'react-select';

import useAdminCreditUsageFilters from '@features/admin-credit-usage/hooks/useAdminCreditUsageFilters.tsx';
import ReactSelect from '@components/StyledReactSelect/StyledReactSelect.tsx';
import { Option } from '@utils/react-select.ts';
import Box from '@mui/material/Box';
import CustomDatePicker from '@components/DatePicker';
import styles from './index.module.scss';

const intervalOptions: MultiValue<Option> = [
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
  { value: 'quarter', label: 'Quarter' },
  { value: 'year', label: 'Year' },
];

const creditTypeOptions: MultiValue<Option> = [
  { value: 'all', label: 'All Types' },
  { value: 'case', label: 'Case Credits' },
  { value: 'demand_letter', label: 'Demand Letter Credits' },
  { value: 'deposition', label: 'Deposition Credits' },
];

function AdminCreditUsageFilters() {
  const {
    selectedCreditType,
    setSelectedCreditType,
    selectedInterval,
    setSelectedInterval,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
  } = useAdminCreditUsageFilters();

  return (
    <div className={styles.filtersContainer}>
      <div />
      <Box
        display="flex"
        gap={2}
        sx={{
          flexDirection: { xs: 'column', sm: 'column', lg: 'row' },
          flexGrow: { xs: 1, sm: 1, lg: 0 },
        }}
      >
        <CustomDatePicker
          selected={startDate}
          placeholder="Select a start date"
          onChange={setStartDate}
          prefix="From"
        />
        <CustomDatePicker
          selected={endDate}
          placeholder="Select an end date"
          onChange={setEndDate}
          prefix="To"
        />
        <ReactSelect
          value={selectedInterval}
          placeholder="Select interval"
          onChange={(newValue) =>
            newValue && setSelectedInterval(newValue as Option)
          }
          options={intervalOptions}
          className={styles.select}
        />
        <ReactSelect
          value={selectedCreditType}
          placeholder="Select credit type"
          onChange={(newValue) =>
            newValue && setSelectedCreditType(newValue as Option)
          }
          options={creditTypeOptions}
          className={styles.select}
        />
      </Box>
    </div>
  );
}

export default AdminCreditUsageFilters;
